import notification from '@/api/administrator/notification-template'
import lang from '@/api/lang'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState
}

export const getters = {}

export const mutations = {
  ...baseMutations
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        include: 'not_type,language',
      },
      attrubutes
    )
    return notification.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return notification.store(data)
  },
  update(context, { id, data }) {
    return notification.update(id, data)
  },
  destroy(context, id) {
    return notification.destroy(id)
  },
  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await notification.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },
  getLang(context) {
    return lang.get()
  },
  getNotType(context) {
    return notification.getNotType()
  },
  getNotChannel(context) {
    return notification.getNotChannel()
  },
  getNotParam(context, attrubutes = {}) {
    return notification.getNotParam({
      params: attrubutes
    })
  }
}
